module.exports = __webpack_public_path__ + "media/images/404Icon-bc5cbb47a74f7058c9a04e05c3968261.svg";